/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EsignOperatorCancellationReason = {
    ResidentRefusedToSign: 'resident_refused_to_sign',
    ResidentDischargedBeforeSigning: 'resident_discharged_before_signing',
    ResidentDeceased: 'resident_deceased',
    NeverAdmittedReferralLost: 'never_admitted_referral_lost',
    PaperworkNotNeededReadmit: 'paperwork_not_needed_readmit',
    DuplicateOrSentInError: 'duplicate_or_sent_in_error',
    Other: 'other',
} as const;
export type EsignOperatorCancellationReason = typeof EsignOperatorCancellationReason[keyof typeof EsignOperatorCancellationReason];


export function instanceOfEsignOperatorCancellationReason(value: any): boolean {
    for (const key in EsignOperatorCancellationReason) {
        if (Object.prototype.hasOwnProperty.call(EsignOperatorCancellationReason, key)) {
            if (EsignOperatorCancellationReason[key as keyof typeof EsignOperatorCancellationReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EsignOperatorCancellationReasonFromJSON(json: any): EsignOperatorCancellationReason {
    return EsignOperatorCancellationReasonFromJSONTyped(json, false);
}

export function EsignOperatorCancellationReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): EsignOperatorCancellationReason {
    return json as EsignOperatorCancellationReason;
}

export function EsignOperatorCancellationReasonToJSON(value?: EsignOperatorCancellationReason | null): any {
    return value as any;
}

export function EsignOperatorCancellationReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): EsignOperatorCancellationReason {
    return value as EsignOperatorCancellationReason;
}

